import { isPlatformBrowser, Location } from '@angular/common';
import { Component, inject, PLATFORM_ID, APP_INITIALIZER } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AllLocalStorageService } from './services/all-local-storage.service';
import { AnalyticsService } from './services/analytics.service';
import { GeneralService } from './services/general.service';
import { SesionService } from './services/sesion.service';
import { WebServicesService } from './services/web-services.service';
import { GoogleMapsService } from './services/google-maps.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  providers: [
    SesionService,
    WebServicesService,
    AnalyticsService,
    CookieService,
    AllLocalStorageService,
    GeneralService,

  ]
})
export class AppComponent {
  googleMapsService = inject(GoogleMapsService)
  platformId = inject(PLATFORM_ID)
  isBrowser: boolean
  title = 'ChilePasajes';
  styles: any;
  complement: any;
  complement2: any;
  hash: string;
  nonce: string;
  loadingScreenEl: any;
  nameInterval: any;
  complementsArray: string[] = [
    'buses-altas-cumbres', 
    'buses-casther', 'buses-erbuc', 
    'buses-expreso-del-sur', 
    'buses-jeldres', 'buses-rcb', 
    'buses-rimar', 
    'buses-sanhueza', 
    'buses-sol-del-pacifico', 
    'buses-tra', 
    'buses-transantin', 
    'vamos',
    'chi-ar', 
    'chile-pruebas', 
    'cikbus', 
    'cikbus-express',
    'expreso-santa-cruz',
    'hualpen', 
    'marga-taqsa', 
    'movired', 
    'narbus', 
    'pasajes-buscador', 
    'pullman-jc', 
    'pullman-lago-penuelas', 
    'pullman-setter', 
    'ruta-bus-78'
  ];

  trackingCode: string;

  constructor(public sesion: SesionService,
    public ws: WebServicesService,
    public activatedRoute: ActivatedRoute,
    private readonly analyticsService: AnalyticsService,
    private router: Router,
    public cookieService: CookieService,
    private allLocalStorageService: AllLocalStorageService,
    private generalService: GeneralService,
    private translateService: TranslateService,
    private location: Location
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId)
    this.generalService.eliminarPorDia();

    // init translate service
  }

  ngOnInit() {

    if (this.isBrowser) {
      this.analyticsService.init();
      this.googleMapsService.loadScript()
      this.contadorHistorial();

      // handle language from url
      let url: string = this.location.path();
      if (url.includes('/en/') || url === '/en') {
        this.translateService.use('en');
      }

      const now = new Date();
      now.setHours(now.getHours() + 1);
      this.activatedRoute.queryParams
        .subscribe(params => {

          if (params.gclid) {
            this.cookieService.delete("adwords");
            this.cookieService.set("adwords", "1", now);
          } else {
            this.cookieService.delete("adwords");
            this.cookieService.set("adwords", "0", now);
          }
          if (params.utm_source) {
            this.cookieService.delete("utm_source");
            this.cookieService.set("utm_source", this.ws.sanitize(params.utm_source), now);
          }
          if (params.utm_campaign) {
            this.cookieService.delete("utm_campaign");
            this.cookieService.set("utm_campaign", this.ws.sanitize(params.utm_campaign), now);
          }
          if (params.utm_medium) {
            this.cookieService.delete("utm_medium");
            this.cookieService.set("utm_medium", this.ws.sanitize(params.utm_medium), now);
          }
        }
        );

        this.logoutLegacy();

    }
  }

  ngAfterViewInit(): void {
  }

  contadorHistorial() {
    if (isPlatformBrowser(this.platformId)) {
      clearInterval(this.nameInterval);
      this.nameInterval = setInterval(() => {
        const marcaTiempoActual: number = parseInt(this.generalService.obtenerMarcaDeTiempo());
        let m_a_i: number = parseInt(localStorage.getItem("m_a_i")); // marca asientos ida
        let m_u_v: number = parseInt(localStorage.getItem("m_u_v")); // marca url volver
        let m_d_p: number = parseInt(localStorage.getItem("m_d_p")); // marca data pago
        let m_d_c_p: number = parseInt(localStorage.getItem("m_d_c_p")); // marca datos cliente pago
        let m_s_i: number = parseInt(localStorage.getItem("m_s_i")) // marca sesion id
        let m_a_v: number = parseInt(localStorage.getItem("m_a_v")); // marca asientos vuelta
        let m_v_i: number = parseInt(localStorage.getItem("m_v_i")); // marca viajes ida
        let m_v_v: number = parseInt(localStorage.getItem("m_v_v")); // marca viajes vuelta
        let m_h_v_i: number = parseInt(localStorage.getItem("m_h_v_i")); // marca historial viaje ida
        let m_t_c: number = parseInt(localStorage.getItem("m_t_c")); // marca tiempo compra

        switch (true) {
          case m_u_v && (marcaTiempoActual - m_u_v) >= 2015:
            this.allLocalStorageService.eliminarUrlVolver(this.ws.newComplemt);
            localStorage.removeItem("m_u_v");
            break;
          case m_d_p && (marcaTiempoActual - m_d_p) >= 1015:
            this.allLocalStorageService.eliminarDataPago(this.ws.newComplemt);
            localStorage.removeItem("m_d_p");
            break;
          case m_d_c_p && (marcaTiempoActual - m_d_c_p) >= 1015:
            this.allLocalStorageService.eliminarDatosClientePago(this.ws.newComplemt);
            localStorage.removeItem("m_d_c_p");
            break;
          case m_s_i && (marcaTiempoActual - m_s_i) >= 1015:
            this.allLocalStorageService.eliminarSesionID(this.ws.newComplemt);
            localStorage.removeItem("m_s_i");
            break;
          case m_a_i && (marcaTiempoActual - m_a_i) >= 1015:
            this.allLocalStorageService.eliminarAsientosIda(this.ws.newComplemt);
            localStorage.removeItem("m_a_i");
            break;
          case m_a_v && (marcaTiempoActual - m_a_v) >= 1015:
            this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
            localStorage.removeItem("m_a_v");
            break;
          case m_v_i && (marcaTiempoActual - m_v_i) >= 1015:
            this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
            localStorage.removeItem("m_v_i");
            break;
          case m_v_v && (marcaTiempoActual - m_v_v) >= 1015:
            this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
            localStorage.removeItem("m_v_v");
            break;
          case m_h_v_i && (marcaTiempoActual - m_h_v_i) >= 1015:
            this.allLocalStorageService.eliminarHistorialViajeIda(this.ws.newComplemt);
            localStorage.removeItem("m_h_v_i");
            break;
          case m_t_c && (marcaTiempoActual - m_t_c) >= 1015:
            localStorage.removeItem(`FISKNdks-${this.ws.newComplemt}`);
            localStorage.removeItem("m_t_c");
            break;
          default:
            //Declaraciones ejecutadas cuando ninguno de los valores coincide con el valor de la expresión
            break;
        }

      }, 1000);
    }
  }

  onActivate(event) {
    if (isPlatformBrowser(this.platformId)) {
      let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
          window.scrollTo(0, pos - 20); // how far to scroll on each step
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 25);
    }

    this.ws.newDomainUrlName = 'Chilepasajes.cl';
    this.ws.newDomainName = 'chilepasajes';
    this.ws.newDomainLogo = 'pasajes.png';
    this.complement = "pasajes";
    this.complement2 = "pasajes";
    this.ws.newDomainUrl = "chilepasajes.cl";

    if (this.complement != 'buses-altas-cumbres') {
      // this.analyticsService.init();
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          try {
            (window as any).ga('set', 'page', event.urlAfterRedirects);
            (window as any).ga('set', 'title', event.urlAfterRedirects);
            (window as any).ga('send', 'pageview');
          } catch (error) {

          }
        }
      });
    }
  }

  // LOGOUT everyone who doesn't have the isNotLegacy flag
  logoutLegacy() {
    // retrieve flag from local storage    
    if (!localStorage) return;

    const isNewLogin = localStorage.getItem('isNewLogin')

    if (!this.sesion.getUser()) return;

    if (!isNewLogin) {
      // logout -> delete jwt, delete user, set isNotLegacy to true
      this.sesion.deleteAccessToken();
      this.sesion.deleteUser();
      localStorage.setItem('isNewLogin', 'true');

      // alert the user
      Swal.fire({
        title: 'Sesión expirada',
        text: 'Por favor, inicie sesión nuevamente',
        icon: 'error',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then(() => {
        // reload the page
        window.location.reload();
      })
    }
  }
}